import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { getReplacers } from '../api'
import { replacersKeys } from '../queryKeys'

const useGetReplacersQuery = ({
  enabled = true,
  nodeIds,
}: {
  enabled: boolean
  nodeIds: string[]
}) => {
  const getReplacersQuery = useQuery({
    queryKey: replacersKeys.all,
    queryFn: () => getReplacers(nodeIds),
    enabled,
  })

  return getReplacersQuery
}

export default useGetReplacersQuery
